module.exports = __webpack_public_path__ + "img/Payment_Flash_active.46700283.png";